//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '../i18n.js'
import { dateTimeFormatter, isEqualDateStr, getLunarDate, getLunarDateString, lunarDate } from '../tools.js'

const inBrowser = typeof window !== 'undefined'
export default {
  name: 'cal-panel',
  data () {
    return {
      i18n,
      fingerOver: 0,
      fingerClick: 0,
      lunarDate
    }
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    calendar: {
      type: Object,
      required: true
    },
    selectedDay: {
      type: String,
      required: false
    },
    showLunar: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    dayList () {
      let firstDay = new Date(this.calendar.params.curYear, this.calendar.params.curMonth, 1)
      let dayOfWeek = firstDay.getDay()
      // 根据当前日期计算偏移量 // Calculate the offset based on the current date
      if (this.calendar.options.weekStartOn > dayOfWeek) {
        dayOfWeek = dayOfWeek - this.calendar.options.weekStartOn + 7
      } else {
        dayOfWeek = dayOfWeek - this.calendar.options.weekStartOn
      }

      let startDate = new Date(firstDay)

      startDate.setDate(firstDay.getDate() - dayOfWeek)

      let item, flag, tempArr = [], tempItem
      for (let i = 0; i < 35; i++) {
        item = new Date(startDate)
        item.setDate(startDate.getDate() + i)

        if (this.calendar.params.curMonth === item.getMonth()) {
          flag = 1
        } else {
          flag = 0
        }
        tempItem = {
          date: `${item.getFullYear()}-${item.getMonth() + 1}-${item.getDate()}`,
          flag: flag,
          status: 0
        }
        this.events.forEach((event) => {
          if (isEqualDateStr(event.date, tempItem.date)) {
            tempItem.status = event.status
            tempItem.status2 = event.status2
            tempItem.status2Data = event.status2Data
          }
        })
        tempArr.push(tempItem)
      }
      return tempArr
    },
    today () {
      let dateObj = new Date()
      return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`
    },
    curYearMonth () {
      // let tempDate = Date.parse(new Date(`${this.calendar.params.curYear}-${this.calendar.params.curMonth+1}-01`))
      // return dateTimeFormatter(tempDate, this.i18n[this.calendar.options.locale].format)

      // 解决IE还有safari日历头不兼容问题
      let curMonth = +this.calendar.params.curMonth + 1
      if (curMonth < 10) {
        curMonth = '0' + curMonth
      }
      return this.calendar.params.curYear + '年' + curMonth + '月'
    },
    customColor () {
      return this.calendar.options.color
    }
  },
  created () {
    // console.log(lunarDate('2019-9-10'))
  },
  methods: {
    dateClick (date, data) {
      this.fingerClick = date
      this.$emit('show-schedule', date, data)
    },
    fingerOverChange (data, allData) {
      this.fingerOver = data
      this.$emit('mouseover-date', data, allData)
    },
    fingerLeaveChange (data, allData) {
      this.fingerOver = 0
      this.$emit('mouseleave-date', data, allData)
    },
    nextMonth () {
      this.$EventCalendar.nextMonth()

      this.$emit('month-changed', this.transferYearMouth(this.curYearMonth))
    },
    preMonth () {
      this.$EventCalendar.preMonth()
      this.$emit('month-changed', this.transferYearMouth(this.curYearMonth))
    },
    handleChangeCurday (date) {
      if (date.status) {
        this.$emit('cur-day-changed', date.date)
      }
    },
    transferYearMouth (val) { // 转换年月
      let year = val.substring(0, 4)
      let mouth = val.substring(5, 7)
      return year + '-' + mouth
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/calendar/components/cal-panel.vue